export const jestImages = {
    left: {
        paper: "/roshambo/gestures/left/paper_jest.png",
        scissors: "/roshambo/gestures/left/scissors_jest.png",
        rock: "/roshambo/gestures/left/rock_jest.png",
    },
    right: {
        paper: "/roshambo/gestures/right/paper.png",
        scissors: "/roshambo/gestures/right/scissors.png",
        rock: "/roshambo/gestures/right/rock.png",
    }
}